export const UNIFIED_JOURNAL_BETA_STORAGE_KEY = 'bandz-unified-journal-beta';

export function readUnifiedJournalBetaCache() {
  try {
    const savedValue = localStorage.getItem(UNIFIED_JOURNAL_BETA_STORAGE_KEY);
    return savedValue === null ? true : savedValue === 'true';
  } catch (_) {
    return true;
  }
}

export function writeUnifiedJournalBetaCache(enabled) {
  try {
    localStorage.setItem(UNIFIED_JOURNAL_BETA_STORAGE_KEY, enabled === true ? 'true' : 'false');
  } catch (_) {
    // Local storage is only a same-device speed-up; Firestore remains authoritative.
  }
}
